import * as React from 'react'
import App from './App'
import {hydrateRoot} from 'react-dom/client'

const container = document.getElementById('root')
hydrateRoot(container as HTMLElement, <App />)
